import { site } from "@/lib/seo";
import { env } from "@/lib/environment";

export const PAGE_NAME = "Book Your digital signage demo";
export const PAGE_DESCRIPTION =
  "Book a personalized demo of Pickcel's Digital Signage software. See how our platform can transform your business communications.";
export const PAGE_URL = `${site.url}/book-a-demo`;
export const KEYWORDS = [
  "book a demo",
  "digital signage demo",
  "pickcel demo",
  "free demo",
  "product demo",
];

export const schemaOptions = {
  pageName: PAGE_NAME,
  pageDescription: PAGE_DESCRIPTION,
  pageUrl: PAGE_URL,
  keywords: KEYWORDS,
  pageOgImages: {
    facebook: [
      `${env.NEXT_PUBLIC_CDN_URL}/images/shared/og/contact-fb.4gw0uHtHNT7q.jpg`,
    ],
    twitter: [
      `${env.NEXT_PUBLIC_CDN_URL}/images/shared/og/contact-tr.prezDQrvd-mr.jpg`,
    ],
  },
  breadcrumbs: [
    { name: "Home", url: "https://www.pickcel.com/" },
    { name: PAGE_NAME, url: PAGE_URL },
  ],
};
